import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente TanStack Query com defaults seguros para o PEP-VIDA.
 * - 1 retry em queries, 0 em mutations (não queremos duplicar POSTs)
 * - staleTime de 30s para dados que não mudam rápido
 * - refetch on window focus desativado (médico não muda de aba)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
